import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { Col, Collapse, Nav, NavItem, NavLink, Row } from 'reactstrap';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { setPanelsAndNavigationEnabled } from '../../redux/MiscSlice';
import { UserRoleEnum, selectUser } from '../../redux/UserSlice';
import Page from '../Page';
import NavigationPanelItem from '../core/NavigationPanelItem';
import AdHocReporter from './AdHocReporter';
import ReportNavigator from './ReportNavigator';
import GeoLocationMap from './StateMap/GeoLocationMap';
import SystemReports from './SystemReports';
import VisualizationView from './VisualizationView/VisualizationView';

const GeoLocationSelector = () => {

    const dispatch = useAppDispatch();

    const history = useHistory();

    const userData = useAppSelector(selectUser);

    const isNotLoggedIn = userData == null || userData == undefined || userData.userProfile == null || userData.userProfile == undefined ;

    const isAdmin = userData != null &&
        userData.userProfile != null ? userData.userProfile.role == UserRoleEnum.Admin : false;

    const [selectedReportsModule, setSelectedReportsModule] = React.useState<'SUBMITTED' | 'SYSTEM' | 'ADHOC' | 'HOME' | 'MENU' | 'VISUAL'>('SUBMITTED');
    const [preSelectedEntityList, setPreSelectedEntityList] = React.useState<Array<string>>([]);
    const [isDragging, setIsDragging] = React.useState(false);
    const [mouseDownTarget, setMouseDownTarget] = React.useState<EventTarget | null>(null);

    const handleNavMouseDown = (e: React.MouseEvent) => {
        setIsDragging(false);
        setMouseDownTarget(e.target);
    };


    React.useEffect(() => {
        dispatch(setPanelsAndNavigationEnabled(false));
        return () => {
            dispatch(setPanelsAndNavigationEnabled(true));
        };
    }, [dispatch]);

    const geoLocationMapRender = (<React.Fragment>
        <GeoLocationMap
            setSelectedReportsModule={setSelectedReportsModule}
            setPreSelectedEntityList={setPreSelectedEntityList}
        />
    </React.Fragment>);

    const systemReportsRender = (<React.Fragment>
        <Row>
            <Col md="2">
                <NavigationPanelItem
                    active={true}
                    componentName="Choose Report Group">
                    <ReportNavigator />
                </NavigationPanelItem>
            </Col>
            <Col md="10">
                <SystemReports />
            </Col>
        </Row>
    </React.Fragment>);

    const adHocRender = (<React.Fragment>
        <AdHocReporter
            preSelectedEntityList={preSelectedEntityList}
        />
    </React.Fragment>);

    const visualRender = (<React.Fragment>
        <VisualizationView>


        </VisualizationView>
    </React.Fragment>);

    return (
        <React.Fragment>
            <Page>
                <Row className="custom-navlink-header" >
                    <Col md="12">
                        <Nav>
                            <Collapse isOpen={isNotLoggedIn == true}>
                                <NavItem>
                                    <NavLink
                                        href="/LogerX/Login"
                                        className={selectedReportsModule === 'HOME' ? "last-clicked custom-navlink" : "custom-navlink"}
                                        active={selectedReportsModule === 'HOME'}
                                        onMouseDown={handleNavMouseDown}                                                 
                                        onClick={e => {
                                            if (isDragging) {
                                                e.preventDefault();
                                                return;
                                            }
                                            e.preventDefault();
                                            history.push("/Login");
                                        }}
                                    >
                                        Home
                                    </NavLink>
                                </NavItem>
                            </Collapse>

                            <NavItem>
                                <NavLink
                                    href="/LogerX/SubmittedReports"
                                    className={selectedReportsModule === 'SUBMITTED' ? "last-clicked custom-navlink" : "custom-navlink"}
                                    active={selectedReportsModule === 'SUBMITTED'}
                                    onMouseDown={handleNavMouseDown}       
                                    onClick={e => {
                                        if (isDragging) {
                                            e.preventDefault();
                                            return;
                                        }
                                        e.preventDefault();
                                        setSelectedReportsModule('SUBMITTED');
                                    }}
                                >
                                    Submitted AFR Documents
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    href="/LogerX/SystemReports"
                                    className={selectedReportsModule === 'SYSTEM' ? "last-clicked custom-navlink" : "custom-navlink"}
                                    active={selectedReportsModule === 'SYSTEM'}
                                    onMouseDown={handleNavMouseDown}        
                                    onClick={e => {
                                        if (isDragging) {
                                            e.preventDefault();
                                            return;
                                        }
                                        e.preventDefault();
                                        setSelectedReportsModule('SYSTEM');
                                    }}
                                >
                                    System Generated Reports
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    href="/LogerX/AdHocReport"
                                    className={selectedReportsModule === 'ADHOC' ? "last-clicked custom-navlink" : "custom-navlink"}
                                    active={selectedReportsModule === 'ADHOC'}
                                    onMouseDown={handleNavMouseDown}                                 
                                    onClick={e => {
                                        if (isDragging) {
                                            e.preventDefault();
                                            return;
                                        }
                                        e.preventDefault();
                                        setSelectedReportsModule('ADHOC');
                                    }}
                                >
                                    Create Your Own Report
                                </NavLink>
                            </NavItem>

                            <NavItem>
                                <NavLink
                                    href="/LogerX/Visualization"
                                    className={selectedReportsModule === 'VISUAL' ? "last-clicked custom-navlink" : "custom-navlink"}
                                    active={selectedReportsModule === 'VISUAL'}
                                    onMouseDown={handleNavMouseDown}
                                    onClick={e => {
                                        if (isDragging) {
                                            e.preventDefault();
                                            return;
                                        }
                                        e.preventDefault();
                                        setSelectedReportsModule('VISUAL');
                                    }}
                                >
                                    Visualization
                                </NavLink>
                            </NavItem>


                            <Collapse isOpen={isNotLoggedIn == false}>
                                <NavItem>
                                    <NavLink
                                        href={ isAdmin == true? "/LogerX/AdminMenu" : "/LogerX/EntityMenu" }
                                        className={selectedReportsModule === 'MENU' ? "last-clicked custom-navlink" : "custom-navlink"}
                                        active={selectedReportsModule === 'MENU'}
                                        onMouseDown={handleNavMouseDown}
                                        onClick={e => {
                                            if (isDragging) {
                                                e.preventDefault();
                                                return;
                                            }
                                            e.preventDefault();
                                            if (isAdmin == true) {
                                                history.push("/AdminMenu");
                                            } else {
                                                history.push("/EntityMenu");
                                            }
                                            
                                        }}
                                    >
                                        Main Menu
                                    </NavLink>
                                </NavItem>
                            </Collapse>
                        </Nav>
                    </Col>
                </Row>
                <Row>
                    <Col> <br /> </Col>
                </Row>
                <Row>
                    <Col md="12">
                        <Collapse isOpen={selectedReportsModule == 'SUBMITTED'}>
                            {geoLocationMapRender}
                        </Collapse>
                        <Collapse isOpen={selectedReportsModule == 'SYSTEM'}>
                            {systemReportsRender}
                        </Collapse>
                        <Collapse isOpen={selectedReportsModule == 'ADHOC'}>
                            {adHocRender}
                        </Collapse>
                        <Collapse isOpen={selectedReportsModule == 'VISUAL'}>
                            {visualRender}
                        </Collapse>
                    </Col>
                </Row>
            </Page>
        </React.Fragment>
    );

}

export default GeoLocationSelector;